import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Phone, MapPin, Anchor } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-[#0B192C] text-white" data-testid="site-footer">
      <div className="container-x py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-2 max-w-md">
            <Link to="/" className="flex items-center gap-2">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-[#0B192C]">
                <Anchor size={16} strokeWidth={1.8} />
              </span>
              <span className="h-display text-xl font-medium tracking-tight">
                Lofoten <span className="font-light italic opacity-80">By Sea</span>
              </span>
            </Link>
            <p className="mt-6 text-white/70 font-light leading-relaxed">
              {t.footer.tagline}
            </p>
            <div className="mt-8 flex items-center gap-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 hover:border-white/60 transition-colors"
                data-testid="social-instagram"
                aria-label="Instagram"
              >
                <Instagram size={16} />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noreferrer"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 hover:border-white/60 transition-colors"
                data-testid="social-facebook"
                aria-label="Facebook"
              >
                <Facebook size={16} />
              </a>
            </div>
          </div>

          <div>
            <p className="label-eyebrow text-white/60">{t.footer.explore}</p>
            <ul className="mt-5 space-y-3 text-white/80">
              <li><Link to="/" className="hover:text-white transition-colors">{t.nav.home}</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors">{t.nav.about}</Link></li>
              <li><Link to="/activities" className="hover:text-white transition-colors">{t.nav.activities}</Link></li>
              <li><Link to="/booking" className="hover:text-white transition-colors">{t.nav.booking}</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">{t.nav.contact}</Link></li>
            </ul>
          </div>

          <div>
            <p className="label-eyebrow text-white/60">{t.footer.contact}</p>
            <ul className="mt-5 space-y-3 text-white/80 text-[15px]">
              <li className="flex items-start gap-3">
                <Phone size={15} className="mt-1 opacity-70" />
                <a href="tel:+4740157531" className="hover:text-white" data-testid="footer-phone">+47 401 57 531</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={15} className="mt-1 opacity-70" />
                <a href="mailto:franksuhr73@gmail.com" className="hover:text-white" data-testid="footer-email">franksuhr73@gmail.com</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={15} className="mt-1 opacity-70" />
                <span>Svolvær, Lofoten, Norway</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Lofoten By Sea. {t.footer.rights}</p>
          <p className="tracking-wider uppercase">68°N · Arctic Norway</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
